import { atom } from "recoil";

export const sound = atom({
  key: "sound",
  default: true,
});
